"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var react_1 = __importDefault(require("react"));
var withUtils = function (Component) {
    var InnerComponent = function (props) {
        var utils = new Proxy({
            ErrorMessage: function () { return require("./ErrorMessage")["default"]; },
            classNames: function () { return require("classnames"); },
            removeExtraSpaces: function () { return require("./removeExtraSpaces")["default"]; },
            uniqueId: function () { return require("./uniqueId")["default"]; }
        }, {
            get: function (target, property) {
                if (property in target) {
                    return target[property]();
                }
            }
        });
        return react_1["default"].createElement(Component, __assign({ utils: utils }, props));
    };
    InnerComponent.displayName = "withUtils(" + (Component.displayName || Component.name) + ")";
    InnerComponent.WrappedComponent = Component;
    return hoist_non_react_statics_1["default"](InnerComponent, Component);
};
withUtils.displayName = "withUtils";
exports["default"] = withUtils;
